export const DASHBOARD_SUBTITLE =
  "View all your teachers in one place. Administer, edit, and print all current and archived surveys.";

export const CREATE_COACH_BUTTON_TEXT = "New Teacher";

export const NO_RESULTS = "No teachers under selected season.";



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/constants.ts